export const NamishMusic = {
     BrandColor:"#ff0077",
     WhiteColor:"white",
     CenteredText:"center",
     Black:"black",
};